import { Box, Typography } from '@material-ui/core';
import useStyles from './TurboClock.style';

export function TurboClock({ label }: Props) {
  const styles = useStyles();

  if (!label) return null;

  return (
    <Box className={styles.turboClock}>
      <Typography className={styles.turboClockLabel}>{label}</Typography>
    </Box>
  );
}

interface Props {
  label: string;
}
